<template>
  <GaugeWithLabel
    v-model="textSizeMultiplierLocal"
    :is-global="isGlobal"
    gauge-setting-global="textSizeMultiplier"
  >
    {{ t('text_size') }}: {{ textSizeMultiplierLocal }}
  </GaugeWithLabel>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useI18n } from 'vue-i18n';

import GaugeWithLabel from '@/components/domains/chat/common/GaugeWithLabel.vue';
import { useGauge } from '@/composables/shared/useGauge';

const props = withDefaults(
  defineProps<{ isGlobal: boolean; textSizeDefault?: number }>(),
  {
    isGlobal: false,
  }
);

const {
  valueLocal: textSizeMultiplierLocal,
  valueDisplayed: selectedTextSizeMultiplier,
} = useGauge('textSizeMultiplier', props.isGlobal);

const { t } = useI18n();

watch(
  () => props.textSizeDefault,
  (newVal) => {
    if (newVal) {
      textSizeMultiplierLocal.value = newVal;
    }
  }
);

defineExpose({
  textSizeMultiplierLocal,
});
</script>

<style scoped>
  .mic-control-container .accent{
    font-size: 0.75rem;
  }
</style>
